import { HTMLProps } from '@/lib/util/types';

export type DividerProps = {} & HTMLProps<HTMLHRElement>;

export default function Divider({ style, ...props }: DividerProps) {
  return (
    <hr
      style={{
        width: '100%',
        border: 'none',
        height: 0.5,
        backgroundColor: 'color-mix(in srgb, var(--color-border) 80%, transparent)',
        ...style,
      }}
      {...props}
    />
  );
}
